import Rails from '@rails/ujs'
import * as Turbolinks from "turbolinks"
import 'bootstrap'
import "../controllers"

Turbolinks.start()
Rails.start()
